import React from "react";
import { Box, Divider } from "@mui/material";
export default function CommonDivider() {
  return (
    <Box>
      <Divider style={{ borderColor: "rgba(255, 255, 255, 0.05)" }} />
    </Box>
  );
}
